import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { LookupService } from "../../../../shared/services/lookup.service";
import { forkJoin } from "rxjs";
import { KeyValueObject } from "../../../../shared/models/core/KeyValueObject";
import { GridComponent } from "@progress/kendo-angular-grid";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { NewRequestDevice } from "../../../../shared/models/request/new-request/new-request-device";
import { DeviceModelsService } from "../../../../shared/services/device-models.service";
import { DeviceModelDto } from "../../../../shared/models/device/device-model-dto";
import { RequestsService } from "../../../services/requests.service";
import { RequestDevicesService } from "../../../services/request-devices.service";
import { WarehouseStockService } from "../../../services/warehouse-stock.service";
import { Activity } from "../../../models/activity/activity";
import { DialogService } from "@progress/kendo-angular-dialog";
import { DevicesHierarchicalSelectorComponent } from "../../devices-hierarchical-selector/devices-hierarchical-selector.component";
import { ReserveResult } from "../../../enums/reserve-result.enum";
import { RequestTypeService } from "../../../services/request-type.service";

@Component({
	selector: 'setup-device-serial',
	templateUrl: './setup-device-serial.html',
	styleUrls: ['./setup-device-serial.scss',
		'../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
	]
})
export class SetupDeviceSerial implements OnInit {

    @ViewChild("requestDevicesGrid") requestDevicesGrid: GridComponent;

    @Input() requestId: number;
    @Input() activity: Activity;
    @Input() requestTypeId: number;
    
    @Output() onContinueEvent: EventEmitter<any> = new EventEmitter();
    @Output() onCancelEvent: EventEmitter<any> = new EventEmitter();

    dataSaving: boolean = false;
    loading: boolean = false;
	dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

    deviceTypes: KeyValueObject[] = [];
    deviceModels: DeviceModelDto[] = [];
    dropDownDeviceModels: DeviceModelDto[] = [];
    deviceSuppliers: DeviceModelDto[] = [];
    dropDownDeviceSuppliers: DeviceModelDto[] = [];
    warrantyRequestTypes: number[] = [];
    senderWarehouses: KeyValueObject[] = [];
    recipientUserName: string;
    senderWarehouseId: number;

    requestDevices: NewRequestDevice[] = [];
    serialsFrom1C: string[] = [];

    checkboxDisabled: boolean = false;
    saveDisabled: boolean = true;


    constructor(
        public requestsService: RequestsService,
        public deviceModelsService: DeviceModelsService,
        public lookupService: LookupService,
        public requestDevicesService: RequestDevicesService,
        public warehouseStockService: WarehouseStockService,
        public dialogService: DialogService,
        public requestTypesService: RequestTypeService
    ) { }

    ngOnInit(): void {
        let deviceTypes$ = this.lookupService.getData('device-types', null);
		let deviceModels$ = this.deviceModelsService.getAll();
        let warrantyRequestTypes$ = this.requestTypesService.getWarrantyRequestTypes();
        this.initRequestDevices();

        forkJoin(deviceTypes$,  deviceModels$, warrantyRequestTypes$)
            .subscribe(([deviceTypes, deviceModels, warrantyRequestTypes]) => {
                this.deviceTypes = deviceTypes;
                this.deviceModels = deviceModels;
                this.dropDownDeviceModels = [];
                this.deviceSuppliers = this.deviceModels.filter(x => x.parentId == null);
                this.dropDownDeviceSuppliers = [];
                this.warrantyRequestTypes = warrantyRequestTypes;
            });
    }

    initRequestDevices() {
        this.loading = true;
        this.warehouseStockService.getWarehouseSenderRecipientData(this.requestId, this.activity.performerUserId).subscribe(warResp => {
            let senderWarehouse = warResp.senderWarehouses[0];
            this.senderWarehouses = warResp.senderWarehouses;
            this.senderWarehouseId = senderWarehouse.id;
            this.recipientUserName = warResp.recipientUserName;
            this.loadRequestDevices();
        });
    }

    loadRequestDevices() {
        this.loading = true;
        this.warehouseStockService.getRefilItemsForStorekeeper(this.requestId, this.activity.performerUserId, this.senderWarehouseId).subscribe(resp => {
                this.requestDevices = resp.requestDevices;
                this.requestDevices.forEach(f => {
                    f.checkboxDisabled = !!f.sn1C || !f.isAvailableIn1C;
                });
                this.serialsFrom1C = resp.serialsFrom1C;
                this.loading = false;
            });
    }

    saveChanges() {
        this.dataSaving = true;
        this.warehouseStockService.issueItems(this.requestId, this.requestDevices, this.senderWarehouseId).subscribe(res => {
            if (res.isSuccessful) {
                this.onContinueEvent.emit();
            }
            this.dataSaving = false;
        })

        // this.requestsService.saveSerialRequestDevices(this.requestDevices).subscribe(() => {
        //     this.onContinueEvent.emit();
        //     this.dataSaving = false;
        // });
    }

    cancel() {
        this.onCancelEvent.emit();
    }

    getNameById(items: KeyValueObject[] = [], id: number): string {
        return items.some(x => x.id == id)
            ? items.find(x => x.id == id).name
            : '';
    }

    saveRequestDevice({ dataItem }: any) {
    }

    removeRequestDevice({ dataItem }: any) {
    }

    createNewRequestDevice(): NewRequestDevice {
        let device = new NewRequestDevice();
        device.manuallyAdded = true;
        device.requestId = this.requestId;
        device.activityId = this.activity.activityId;
        return device;
    }

    addNewRequestDevice() {
        const dialogRef = this.dialogService.open({ 
            content: DevicesHierarchicalSelectorComponent, 
            title: 'Добавление оборудования',
            width: '80%',
            height: '870px',
            minWidth: '800px'
        });
        const devicesSelector = <DevicesHierarchicalSelectorComponent>dialogRef.content.instance;

        devicesSelector.height = 500;
        devicesSelector.disableFreeItems = !this.isWarrantyRequest;
        devicesSelector.requestId = this.requestId;
        devicesSelector.onCancel.subscribe(() => {
            dialogRef.close();
        });
        devicesSelector.onContinue.subscribe((requestDevices: NewRequestDevice[]) => {
            dialogRef.close();

            requestDevices.forEach(requestDevice => {
                requestDevice.requestId = this.requestId;
                requestDevice.manuallyAdded = true;
                requestDevice.reserveResultId = <number>ReserveResult.notBooked;
            });

            const result: NewRequestDevice[] = [];
            for (const requestDevice of requestDevices) {
                for (let i = 0; i < requestDevice.quantity; i++) {
                    result.push({ ...requestDevice, quantity: 1 });
                }
            }

            this.requestDevices.unshift(...result);
        });
        // this.requestDevicesGrid.addRow(this.createNewRequestDevice())
    }

    public deviceTypeChange(deviceTypeId: number, requestDevice: NewRequestDevice = null) {
        if (requestDevice) {
            requestDevice.deviceModelId = null;
            requestDevice.deviceSupplierId = null;
        }
    }

    public deviceSupplierChange(supplierId: number, requestDevice: NewRequestDevice = null) {
        if (requestDevice) {
            requestDevice.deviceModelId = null;
        }
    }

    public handleDeviceModelsDropdownOpen(deviceSupplierId: number) {
		this.dropDownDeviceModels = this.deviceModels != null && deviceSupplierId
            ? this.deviceModels.filter(x => x.parentId === deviceSupplierId)
            : [];
	}

    public handleDeviceSuppliersDropdownOpen(deviceTypeId: number) {
        this.dropDownDeviceSuppliers = this.deviceModels != null && deviceTypeId
            ? this.deviceSuppliers.filter(x => x.typeId == deviceTypeId)
            : [];
    }

    public editRequestDeviceHandler({ sender, rowIndex, dataItem }) {
        this.handleDeviceSuppliersDropdownOpen(dataItem.deviceTypeId);
        this.handleDeviceModelsDropdownOpen(dataItem.deviceSupplierId);

		sender.editRow(rowIndex);
	}

    public rowClass(args) {
		return {
			'cursor-pointer': true,
            'k-alt': args.dataItem.isAvailableIn1C === true,
            'cell-pink': args.dataItem.isAvailableIn1C === false
		};
	}

    get gridHeight(): number {
        return 400;
    }

    get canSaveChanges(): boolean {
        // return this.requestDevices.every(x => this.requestDeviceValid(x));
        return true;
    }

    requestDeviceValid(requestDevice): boolean {
        return !requestDevice.toDelivery || 
            (requestDevice.toDelivery)
    }

    snChanged(item: NewRequestDevice, sn: string) {
        item.checkboxDisabled = (!!item.sn1C
            && !this.serialsFrom1C.includes(sn))
            || !item.isAvailableIn1C;
    }

    checkboxModelChanged() {
        this.saveDisabled = this.requestDevices.every(s => !s.toDelivery)
    }

    get isWarrantyRequest(): boolean {
        return this.warrantyRequestTypes.some(x => x == this.requestTypeId);
    }
}
